import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { StepsTransitionTimeMs } from '../../utils/const';

const ScrollableBackgroundLayer = ({ className, scrollTo }) => {
  const containerRef = useRef();

  const animateScroll = (container) => {
    const maxScroll = container.clientHeight - window.innerHeight;
    const scrollPosition = (scrollTo / 100) * maxScroll;

    container.style.transition = `top ${ StepsTransitionTimeMs }ms ease-in-out`;
    container.style.top = `-${ scrollPosition }px`;

    const resetTransition = () => {
      container.style.transition = '';
      container.removeEventListener('transitionend', resetTransition);
    };

    container.addEventListener('transitionend', resetTransition);
  };

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      animateScroll(container);
    }

    const timeoutId = setTimeout(() => {
      if (container) {
        container.style.transition = '';
      }
    }, StepsTransitionTimeMs);

    return () => clearTimeout(timeoutId);
  }, [scrollTo]);

  return (
    <div
      ref={ containerRef }
      className={ className }
    />
  );
};

ScrollableBackgroundLayer.propTypes = {
  className: PropTypes.string.isRequired,
  scrollTo: PropTypes.number.isRequired
};

export default ScrollableBackgroundLayer;
